export default "__VITE_ASSET__DHpEp47y__"